import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useToast } from "@/hooks/use-toast";
import { revokeResultFromPatient } from "@/redux/actions/testKitActions";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

const RevokeResultFromPatient = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const params = useParams();
  const dispatch: any = useDispatch();

  const { toast } = useToast();

  const handleSubmit = () => {
    dispatch(
      revokeResultFromPatient(
        Number(params.id),
        () => setIsOpen(false),
        () =>
          toast({
            variant: "destructive",
            description: "Error in revoking result from patient",
          })
      )
    );
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="secondary">Revoke Result from Patient</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Revoke Result from Patient</DialogTitle>
          <DialogDescription>
            Revoke the result of the test kit from the patient.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="submit" onClick={() => handleSubmit()}>
            Revoke
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RevokeResultFromPatient;
